export default __webpack_public_path__ + "static/media/RequisitionIcon.10f81bd7.svg";